import React, { useMemo } from 'react';

import FormLayout from '@/components/Form/components/FormLayout';

import { FormAddContentProps } from './types';
import AddContents from '.';

const AddContentsLayout = (props: FormAddContentProps) => {
  const {
    label,
    className,
    onChange,
    value,
    shareable,
    generatedBy,
    disabled,
    isPreWorkPostWorkRequired,
  } = props;
  const { title, description, actionText, modal, deleteText } = label;

  const labels = useMemo(
    () => ({
      modal,
      actionText,
      deleteText,
    }),
    [actionText, deleteText, modal],
  );

  return (
    <FormLayout className={className}>
      <FormLayout.Title>{title}</FormLayout.Title>
      <FormLayout.Description>{description}</FormLayout.Description>
      <AddContents
        disabled={disabled}
        generatedBy={generatedBy}
        isPreWorkPostWorkRequired={isPreWorkPostWorkRequired}
        label={labels}
        selectedValues={value}
        shareable={shareable}
        onChange={onChange}
      />
    </FormLayout>
  );
};

export default React.memo(AddContentsLayout);
